module.exports = __webpack_public_path__ + "static/media/Ford-Ranger-III-Double-Cab-facelift-2019.ba2b110f.jpg";